import React, { useState } from 'react'
import { FaTshirt } from 'react-icons/fa'
import { productImageUrl } from '../lib/images'

/**
 * A product thumbnail that degrades to a garment glyph.
 *
 * Every list in the panel shows one of these, and a broken-image icon repeated
 * down a table reads as "this app is broken" rather than "this product has no
 * photograph". Tracking the failure in state and swapping to a placeholder keeps
 * the row looking deliberate.
 */
const Thumb = ({ src, alt = '', size = 40, className = '' }) => {
  const [failed, setFailed] = useState(false)
  const url = productImageUrl(src)
  // 'full' fills whatever box the caller already sized — a responsive grid
  // card, say — instead of forcing a fixed pixel square.
  const fluid = size === 'full'

  return (
    <span
      className={`grid shrink-0 place-items-center overflow-hidden rounded-md border border-hairline bg-plane ${
        fluid ? 'h-full w-full' : ''
      } ${className}`}
      style={fluid ? undefined : { width: size, height: size }}
    >
      {url && !failed ? (
        <img
          src={url}
          alt={alt}
          loading="lazy"
          decoding="async"
          className="h-full w-full object-contain"
          onError={() => setFailed(true)}
        />
      ) : (
        <FaTshirt className="text-ink-muted/40" style={{ fontSize: fluid ? '2rem' : size * 0.4 }} aria-hidden="true" />
      )}
    </span>
  )
}

export default Thumb
